import { jsxs as R, jsx as o } from "@emotion/react/jsx-runtime";
import { customIconSize as u, buttonFontSize as _ } from "./helper.js";
import { getColorText as s } from "./utils.js";
import { Icon as y } from "../Icon/index.js";
import { Loader as q } from "../Loader/index.js";
import { Text as v } from "../Text/index.js";
import { Tooltip as G } from "../Tooltip/index.js";
import { useButtonKeyboardEvent as H } from "./hooks/useButtonKeyboardEvent.js";
import { StyledCenteredStack as J, StyledTextButton as L, StyledOutlinedButton as P, StyledContainedButton as Q } from "./variants/core.styled.js";
const U = {
  contained: {
    button: Q
  },
  outlined: {
    button: P
  },
  text: {
    button: L
  }
}, st = ({
  type: S = "button",
  className: h,
  dataTrackId: T,
  appearance: t = "contained",
  shape: B = "cube",
  variant: n = "primary",
  size: r = "medium",
  disabled: a = !1,
  icon: l,
  iconPosition: m = "left",
  isLoading: i = !1,
  children: e,
  onClick: d,
  onMouseDown: C,
  onMouseUp: g,
  onMouseOut: I,
  name: w,
  "aria-label": c,
  "aria-labelledby": j,
  "aria-current": A,
  "aria-controls": E,
  "aria-expanded": N,
  "aria-haspopup": O,
  role: V,
  tooltip: p,
  tooltipPlacement: k = "auto",
  tabIndex: W = 0,
  autoFocus: z,
  ref: b,
  ...D
}) => {
  H({
    ref: b,
    onClick: d,
    disabled: a
  });
  const f = a, F = /* @__PURE__ */ R(J, { direction: "row", alignItems: "center", justifyContent: "center", gap: t === "text" ? "4px" : "8px", children: [
    !i && m === "left" && l ? /* @__PURE__ */ o(y, { icon: l, iconSize: u[r], color: s(t, n) }) : null,
    i ? /* @__PURE__ */ o(q, { active: !0, trailColor: t === "contained" ? "theme" : n, size: u[r], color: t === "contained" ? "theme" : n }) : null,
    e && typeof e != "string" ? /* @__PURE__ */ o("div", { children: e }) : /* @__PURE__ */ o(v, { variant: _[r], color: s(t, n), as: "span", oneLine: !0, children: e }),
    !i && m === "right" && l ? /* @__PURE__ */ o(y, { icon: l, iconSize: u[r], color: s(t, n) }) : null
  ] }), K = U[t].button, M = e && typeof e == "string" && e.trim().length > 0 && !c ? void 0 : c, x = /* @__PURE__ */ o(K, { ref: b, role: V, className: h, "data-track": T, disabled: f, appearance: t, shape: B, size: r, type: S, onClick: d, name: w, "aria-label": M, "aria-labelledby": j, "aria-current": A, "aria-controls": E, "aria-expanded": N, "aria-haspopup": O, tabIndex: W, autoFocus: z, onMouseDown: C, onMouseUp: g, onMouseOut: I, variant: n, ...D, children: F });
  return /* @__PURE__ */ o(G, { text: p, placement: k, children: p && f ? /* @__PURE__ */ o("span", { style: {
    display: "inline-block",
    cursor: "not-allowed"
  }, children: x }) : x });
};
export {
  st as Button
};
